
namespace TabAurous.Common {

  
    @Serenity.Decorators.registerClass()
    export class ECommOrderItemsForStockAllocation extends _Ext.GridBase<ECommerce.ECommOrderItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderItems'; }
        protected getDialogType() { return ECommerce.ECommOrderItemsDialog; }
        protected getIdProperty() { return ECommerce.ECommOrderItemsRow.idProperty; }
        protected getInsertPermission() { return ECommerce.ECommOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommerce.ECommOrderItemsRow.localTextPrefix; }
        protected getService() { return ECommerce.ECommOrderForStockAllocationService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};  
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };
        //withBom: boolean;
        constructor(container: JQuery,options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): ECommerce.ECommOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //private getEffectiveValue(item, field): any {
        //    var pending = this.pendingChanges[item.ProductID];
        //    if (pending && pending[field] !== undefined) {
        //        return pending[field];
        //    }

        //    return item[field];
        //}

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}